import { render, staticRenderFns } from "./TqTrivia.vue?vue&type=template&id=19b7fc4f&scoped=true&"
import script from "./TqTrivia.vue?vue&type=script&lang=js&"
export * from "./TqTrivia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b7fc4f",
  null
  
)

export default component.exports